/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Select } from '@atoms';

import { NARROW_COL } from '@constants';
import { BUCKETS } from './constants';
import Form from '../Form';

const BucketSelect = ({ ...props }) => {
  const [bucketIndex, setBucketIndex] = React.useState('en');

  const placeholder = '- Choose a bucket -';
  const bucketMap = BUCKETS;

  return (
    <Form.Item wrapperCol={NARROW_COL} {...props}>
      <Select value={bucketIndex} placeholder={placeholder} onSelect={setBucketIndex} style={{ width: '100%' }}>
        {bucketMap.map(({ label, id }, idx) => (
          <Select.Option key={idx} value={id}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default BucketSelect;
